export default {
    "name": "Kategorieseite: Galerieslider",
    "info_text": "Optimieren Sie die Bedienbarkeit Ihrer Kategorieseite! Unser Plugin ermöglicht es Kunden, bereits durch die Produktbilder zu sliden, während sie die Kategorieseite durchsuchen. Verbessern Sie das Einkaufserlebnis und steigern Sie die Effizienz beim Finden des gewünschten Produkts."
}
